import { Badge } from '../ui/badge';
import { formatGradeOpinion } from './gradeUtils';

interface GradeBadgeProps {
  difficulty: string | null | undefined;
  gradingSystem?: { name: string } | null;
  /** Community average grade opinion (0.1–0.9). Defaults to 0.5 when not set. */
  averageGradeOpinion?: number | null;
  /** 'sm' fits dense lists (e.g. the route-setting board cards). */
  size?: 'sm' | 'default';
}

export function GradeBadge({
  difficulty,
  gradingSystem,
  averageGradeOpinion,
  size = 'default',
}: GradeBadgeProps) {
  if (!difficulty) return null;

  const grade = formatGradeOpinion(difficulty, averageGradeOpinion ?? 0.5);

  return (
    <>
      <Badge
        variant="outline"
        className={size === 'sm' ? 'text-xs font-semibold' : 'text-base font-bold'}
        data-testid="grade-badge"
      >
        {grade}
      </Badge>
      {gradingSystem && (
        <span className={size === 'sm' ? 'text-xs' : 'text-sm'}>({gradingSystem.name})</span>
      )}
    </>
  );
}
